export * from './configuration.model';
export * from './service-type.model';
export * from './service-type-permission.model';
export * from './deal-status.model';
export * from './server-parameter.model';
export * from './wizard-step.model';
export * from './service-item.model';
export * from './deal.model';
export * from './deal-service-item.model';
export * from './deal-term.model';
export * from './deals-wizard.model';
export * from './left-menu-item.model';
export * from './user.model';
export * from './parameter.model';
export * from './term.model';
export * from './deal-signature.model';
export * from './save-page-request.model';
export * from './requests/get-deals-request.model';
export * from './bank.model';
export * from './requests/confirm-password-request.model';
export * from './confirm-password.model';
export * from './deal-custom-model.model';
export * from './credit-card-year.model';
export * from './requests/deal-print-preview-request.model';
export * from './authenticate-response.model';
export * from './requests/change-password-request.model';



// WEBPACK FOOTER //
// ./src/app/_models/_index.ts